import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogVisibilityDropdownContentWireframe from './VeltCommentDialogVisibilityDropdownContentWireframe/VeltCommentDialogVisibilityDropdownContentWireframe';
import VeltCommentDialogVisibilityDropdownTriggerWireframe from './VeltCommentDialogVisibilityDropdownTriggerWireframe/VeltCommentDialogVisibilityDropdownTriggerWireframe';
import { transformWireframeProps } from '../../../utils/propUtils';
;
var VeltCommentDialogVisibilityDropdown = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-visibility-dropdown-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogVisibilityDropdown.Content = VeltCommentDialogVisibilityDropdownContentWireframe;
VeltCommentDialogVisibilityDropdown.Trigger = VeltCommentDialogVisibilityDropdownTriggerWireframe;
export default VeltCommentDialogVisibilityDropdown;
